import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  actionPanel: {
    marginBottom: theme.spacing(2),
  },
  enableFaqBotLabel: {
    marginLeft: theme.spacing(1),
  },
}));
